import { useState } from "react";
import "./ProjectFilter.css";
import { categories } from "../../data/data";

// const filterList = ["paintings", "drawings", "mixmedia"];

export default function ProjectFilter({ changeFilter, setTitle }) {
	const [currentFilter, setCurrentFilter] = useState("paintings");

	const handleClick = (newFilter) => {
		setCurrentFilter(newFilter.value);
		changeFilter(newFilter.value);
		setTitle(newFilter.label);
	};

	return (
		<div className='project-filter'>
			<nav>
				{/* <p>Filter by: </p> */}
				{categories.map((f) => (
					<button
						key={f.id}
						onClick={() => handleClick(f)}
						className={currentFilter === f ? "active" : ""}
					>
						{f.label}
					</button>
				))}
			</nav>
		</div>
	);
}
